<template>
  <v-container fluid class="mt-4">
  	<v-row>
  		<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		  	<span class="text-subtitle-1">Nuevo Dashboard</span>
	  		    <v-radio-group
				      v-model="escuela"
				      class="ml-4"
				      row
				    >
				      <v-radio
				        label="FAST"
				        :value="2"
				      ></v-radio>
				      <v-radio
				        label="INBI"
				        :value="1"
				      ></v-radio>
				    </v-radio-group>
	  		    <v-spacer></v-spacer>
	  		    <v-btn color="primary" @click="initialize()">Buscar</v-btn>
	  		  </v-card-title>



	  		 	<v-card-text>
	  		 		<v-row>
	  		 			<v-col cols="12" md="6" lg="2">
			  		    <v-text-field
			  		      label="Fecha de inicio"
			  		      filled
			  		      hide-details
			  		      dense
			  		      type="date"
			  		      rounded
			  		      v-model="fecha_inicio"
			  		    ></v-text-field>
			  		   </v-col>

			  		   <v-col cols="12" md="6" lg="2">
			  		    <v-text-field
			  		      label="Fecha final"
			  		      filled
			  		      hide-details
			  		      dense
			  		      type="date"
			  		      rounded
			  		      v-model="fecha_final"
			  		    ></v-text-field>
	  		 			</v-col>
	  		 			<v-col cols="12" sm="6" lg="3" xl="3">
						    <v-autocomplete
						    	filled
						      :items="filterPlanteles"
						      v-model="plantel"
						      label="Plantel"
						      clearable
						      dense
						      rounded
						      item-text="plantel"
						      item-value="idplantel"
						    ></v-autocomplete>
            	</v-col>

	  		 		</v-row>
				    <v-row>
				    	<!-- Medio de contacto -->
				      <v-col cols="12" md="8" lg="6">
				        <v-card class="elevation-0 transparent">
							    <v-card-title class="align-start text-subtitle-1">
							    	Gráfica de calor
							      <v-spacer></v-spacer>
							    </v-card-title>

							    <v-card-text>
							      <div>
									    <apexchart
									      type="heatmap"
									      :options="chartOptions"
									      :series="edadvshora"
									      height="450"
									    ></apexchart>
									  </div>
							    </v-card-text>
							  </v-card>
				      </v-col>


				      <!-- Medio de contacto -->
				      <v-col cols="12" md="8" lg="6">
				        <v-card class="elevation-0 transparent">
							    <v-card-title class="align-start text-subtitle-1">
							    	Gráfica de área
							      <v-spacer></v-spacer>
							    </v-card-title>

							    <v-card-text>
							      <div>
									    <apexchart
									      type="area"
									      height="350"
									      :options="chartOptionsFM"
									      :series="seriesFM"
									    />
									  </div>
							    </v-card-text>
							  </v-card>
				      </v-col>


				      <!-- Medio de contacto -->
				      <v-col cols="12" md="8" lg="6">
				        <v-card class="elevation-0 transparent">
							    <v-card-title class="align-start text-subtitle-1">
							    	Gráfica de área
							      <v-spacer></v-spacer>
							    </v-card-title>

							    <v-card-text>
							      <div>
									    <apexchart
									      type="area"
									      height="350"
									      :options="chartOptionsFE"
									      :series="seriesFE"
									    />
									  </div>
							    </v-card-text>
							  </v-card>
				      </v-col>

				      <!-- Medio de contacto -->
				      <v-col cols="12" md="8" lg="6">
				        <v-card class="elevation-0 transparent">
							    <v-card-title class="align-start text-subtitle-1">
							    	Gráfica Piramidal
							      <v-spacer></v-spacer>
							    </v-card-title>

							    <v-card-text>
							      <div>
									    <apexchart
									      type="bar"
									      height="350"
									      :options="chartOptionsPyramid"
									      :series="seriesFES"
									    />
									  </div>
							    </v-card-text>
							  </v-card>
				      </v-col>

				    </v-row>
	  		  </v-card-text>

	  		</v-card>
  		</v-col>
  	</v-row>


    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import VueApexCharts from 'vue-apexcharts'

  import validarErrores  from '@/mixins/validarErrores'
  import funcionesExcel  from '@/mixins/funcionesExcel'

  import Chart from "@/plugins/chart";

  import am5index from "@amcharts/amcharts5/index";
	import am5xy from "@amcharts/amcharts5/xy";
	import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

  export default {

  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      escuela: 1,

  		fecha_inicio:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			fecha_final: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      edadvshora: [],

      planteles:[],

      plantel: null,

      seriesFM:[],
			fechasFM:[],

      chartOptions: {
        chart: {
          type: 'heatmap',
        },
        dataLabels: {
          enabled: false
        },
        colors: ["#008FFB"],
        title: {
          text: 'Gráfica de calor ( edad vs hora ) / Inscritos'
        },
      },

      chartOptionsFM: {
        chart: {
          type: 'area',
          height: 350,
          toolbar: { show: false }
        },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth' },
        xaxis: {
          type: 'category',
          categories: [],
          title: { text: 'Fecha' }
        },
        yaxis: {
          title: { text: 'Registros' }
        },
        colors: ['#008FFB', '#FEB019'],
        tooltip: {
          x: { format: 'yyyy-MM-dd' }
        },
        title: {
          text: 'Modalidad vs Fecha',
          align: 'center'
        }
      },

      seriesFE:[],
			fechasFE:[],

			chartOptionsFE: {
        chart: {
          type: 'area',
          height: 350,
          toolbar: { show: false }
        },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth' },
        xaxis: {
          type: 'category',
          categories: [],
          title: { text: 'Fecha' }
        },
        yaxis: {
          title: { text: 'Registros' }
        },
        colors: [
			    '#008FFB', // azul
			    '#FEB019', // naranja
			    '#00E396', // verde
			    '#775DD0', // morado
			    '#FF4560', // rojo
			    '#3F51B5', // índigo
			    '#546E7A', // gris azulado
			    '#26A69A'  // turquesa
			  ],
        tooltip: {
          x: { format: 'yyyy-MM-dd' }
        },
        title: {
          text: 'Edad vs Fecha',
          align: 'center'
        }
      },

      seriesFES:[],
			categoriesFES:[],

			usePercent: false,

      chartOptionsPyramid: {
			  chart: { type: 'bar', stacked: true, height: 400, toolbar: { show:false } },
			  plotOptions: { bar: { horizontal: true, barHeight: '70%' } },
			  colors: ['#008FFB', '#FF69B4'], // H / M
			  dataLabels: {
			    enabled: true,
			    formatter: (val) => Math.abs(val).toFixed( 0 ) + ('')
			  },
			  xaxis: {
			    categories: [], // se rellena abajo
			    title: { text: 'Cantidad' },
        	labels: { formatter: (v) => Math.abs(v) + ( '') }
			  },
			  yaxis: { title: { text: '' } },
			  tooltip: {
			    y: { formatter: (val) => Math.abs(val) + ( '') }
			  },
			  title: { text: 'Distribución por género y edad', align: 'center' },
			  legend: { position: 'bottom' }
			}

  	}),

	  async created(){
	  	await this.initialize()
	  	await this.getPlanteles()
	  },


	  methods:{
	  	
	  	async initialize(){
	  		
	  		// Abrimos modal de carga
        this.cargar = true

        try{

        	// Hacemos el cuerpo de la petición
        	const payload = {
        		fecha_inicio: this.fecha_inicio,
						fecha_final : this.fecha_final,
						escuela     : this.escuela,
						plantel     : this.plantel
        	}

        	// Hacemos la petición
        	const respuesta = await this.$http.post('mkt.dashboard.nuevo', payload )

        	// Guardamos los datos de la gráfica de calor
        	this.edadvshora = respuesta.data.edadvshora
        	this.seriesFM   = respuesta.data.seriesFM
					this.fechasFM   = respuesta.data.fechasFM
					this.seriesFE   = respuesta.data.seriesFE
					this.fechasFE   = respuesta.data.fechasFE

					this.chartOptionsFM = {
				    ...this.chartOptionsFM,
				    xaxis: { ...this.chartOptionsFM.xaxis, categories: this.fechasFM }
				  };

				  this.chartOptionsFE = {
				    ...this.chartOptionsFE,
				    xaxis: { ...this.chartOptionsFE.xaxis, categories: this.fechasFE }
				  };

				  this.seriesFES     = respuesta.data.seriesFES
				  this.categoriesFES = respuesta.data.categoriesFES

				  this.seriesPyramid = this.seriesFES;
					this.chartOptionsPyramid = {
					  ...this.chartOptionsPyramid,
					  xaxis: { ...this.chartOptionsPyramid.xaxis, categories: this.categoriesFES }
					};


        }catch( error ){

        	this.validarError( error )

        }finally{

        	this.cargar = false

        }


	  	},

	  	async getPlanteles () {
			  this.cargar = true
			  this.planteles = []

			  try {

			    const response = await this.$http.get('planteles.oficiales')
			    this.planteles = response.data.filter( el => el.deleted == 0 && el.zona != 0 )

			  } catch (error) {
			    const msg = (error && error.response && error.response.data && error.response.data.message)
    								? error.response.data.message
    								: 'Error al obtener planteles'
  				this.validarError(msg)
			  } finally {
			    this.cargar = false
			  }
			},

	  },


	  computed:{

	  	filterPlanteles( ){

      	if( this.escuela == 1){

      		return this.planteles.filter( el => !el.plantel.match('FAST') )

      	}else{

      		return this.planteles.filter( el => el.plantel.match('FAST') )

      	}

      }

	  }
	}
</script>

<style lang="scss" scoped>

</style>